<div class="layout-topbar">
    <div class="layout-topbar-logo-container">
        <button class="layout-menu-button layout-topbar-action" (click)="layoutService.onMenuToggle()">
            <i class="pi pi-bars"></i>
        </button>
        <a class="layout-topbar-logo" routerLink="/">
            <img src="assets/layout/images/{{config.darkTheme ? 'logo-white' : 'logo-dark'}}.png" alt="logo">
        </a>
    </div>

    <div class="layout-topbar-actions" style="display: flex; align-items: center; gap: 1rem;">
        <div class="layout-config-menu hidden lg:flex" style="align-items: center; gap: 0.5rem;">
            <!-- <div style="flex-shrink: 0; display: flex; align-items: center; justify-content: center; width: 2rem; height: 2rem;">
                <i class="pi pi-user"></i></div> -->
            <div style="margin: 0;">
                <div class="secondery-text">{{displayName}}</div>
                <div *ngIf="hasMultiTenant" pTooltip="{{tenantName}}" tooltipPosition="bottom">
                    {{tenantName|ellipsis:20}}</div>
            </div>

            <div class="relative">
                <!-- <button
                    class="layout-topbar-action layout-topbar-action-highlight"
                    pStyleClass="@next"
                    enterFromClass="hidden"
                    enterActiveClass="animate-scalein"
                    leaveToClass="hidden"
                    leaveActiveClass="animate-fadeout"
                    [hideOnOutsideClick]="true"
                >
                    <i class="pi pi-palette"></i>
                </button> -->
                <app-configurator />
            </div>
        </div>

        <button class="layout-topbar-menu-button layout-topbar-action" #menuButton (click)="toggleTopbarMenu()">
            <i class="pi pi-ellipsis-v"></i>
        </button>

        <div class="layout-topbar-menu lg:block" #topbarMenu [ngClass]="{'hidden': !isTopbarMenuOpen, 'lg:!block': true}" (clickOutside)="closeTopbarMenu()">
            <div class="layout-topbar-menu-content">
                <div class="lg:hidden" style="display: flex; align-items: center; gap: 0.5rem; padding: 0.75rem 0; border-bottom: 1px solid var(--surface-border);">
                    <div style="flex-shrink: 0; display: flex; align-items: center; justify-content: center; width: 2rem; height: 2rem;">
                        <i class="pi pi-user"></i>
                    </div>
                    <div style="margin: 0;">
                        <div class="secondery-text">{{displayName}}</div>
                        <div *ngIf="hasMultiTenant">{{tenantName|ellipsis:20}}</div>
                    </div>
                </div>
                <button type="button" class="layout-topbar-action" (click)="toggleDarkMode()">
                    <i
                        [ngClass]="{ 'pi ': true, 'pi-moon': layoutService.isDarkTheme(), 'pi-sun': !layoutService.isDarkTheme() }"></i>
                        <span>{{layoutService.isDarkTheme() ? 'Light Mode' : 'Dark Mode'}}</span>
                </button>
                <!-- <button type="button" class="layout-topbar-action">
                    <i class="pi pi-calendar"></i>
                    <span>Calendar</span>
                </button> -->

                <!-- <button type="button" class="layout-topbar-action">
                    <i class="pi pi-inbox"></i>
                    <span>Messages</span>
                </button> -->
                <button type="button" class="layout-topbar-action" (click)="onLogOffButtonClick($event)">
                    <i class="pi pi-power-off"></i>
                    <span>Log Off</span>
                </button>
            </div>
        </div>
    </div>
</div>